import { render, staticRenderFns } from "./AddAnotherProject-View.vue?vue&type=template&id=4391bc7a&scoped=true&"
import script from "./AddAnotherProject-View.vue?vue&type=script&setup=true&lang=js&"
export * from "./AddAnotherProject-View.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AddAnotherProject-View.vue?vue&type=style&index=0&id=4391bc7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4391bc7a",
  null
  
)

export default component.exports